import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    // maxWidth: 360,
    width: '100%',
    // height: 153,
    borderRadius: 11,
    backgroundColor: '#f1edec',
    cursor: 'pointer',
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%' height='100%' fill='none' rx='11' ry='11' stroke='%23784A42FF' stroke-width='4' stroke-dasharray='11' stroke-dashoffset='13' stroke-linecap='square'/%3e%3c/svg%3e");`
  },

  cardContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: 24,
    flexDirection: 'column'
  },

  contentData: {
    display: 'flex',
    flexDirection: 'column',


    '& :first-child': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '& :last-child': {
      marginTop: 28,
      fontSize: theme.app.typography.h3.fontSize,
      color: theme.app.colors.text.primary
    }
  },

  imagePreview: {
    maxWidth: 650,
    maxHeight: 650,
    borderRadius: theme.app.borderRadius.md,
    objectFit: 'cover',
  },

  errorText: {
    color: theme.app.indication.danger,
    fontSize: theme.app.typography.error.fontSize,
  },

  removeButton: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    padding: '8px 16px 8px 12px',
  }



}))
